import map from "lodash/map"
import { isTeamsitePage } from "utils-lib/isTeamsitePage"
import { getWindow } from "utils-lib/getWindow"
import { isMyWMApp } from "utils-lib/isMyWMApp/index"
import { makeStyles } from "tss-react/mui"
import { Link } from "../../../../Base"
import "./QuickLinks.scss"

const payMyBill = `pay my bill`

const useStyles = makeStyles()(() => ({
  hideLink: {
    display: `none`,
  },
}))

const QuickLinks = ({ columns, hidePayMyBill = false }) => {
  const ssrWindow = getWindow()

  const { classes } = useStyles()

  const renderColumn = (column, index) =>
    column ? (
      <div className="flex-grow-1" key={index} data-testid="quick-Links">
        <div className="QuickLinks__heading">
          <h2 className="maax-font-weight-bold"> {column.columnHeading} </h2>
        </div>
        <div className="mt-3">
          {map(column.quickLinks, (item, index1) => {
            const isExternalLink =
              isMyWMApp ||
              isTeamsitePage(ssrWindow.location.pathname) ||
              item.isExternalLink

            const hideLink =
              hidePayMyBill && item.quickLinkText.toLowerCase() === payMyBill

            return (
              <div className="mb-2" key={index1}>
                <Link
                  href={item.quickLinkPath}
                  analytics_key={item.analyticsKey}
                  isExternalLink={isExternalLink}
                  className={`${
                    hideLink ? classes.hideLink : ``
                  } Footer__quicklink`}
                >
                  {item.quickLinkText}
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    ) : null

  return (
    <>
      {/* desktop version */}
      <div className="d-none d-xl-flex w-100 justify-content-between">
        {map(columns, (item, index1) => (
          <div className="QuickLinks__column" key={index1}>
            {renderColumn(columns[index1], index1)}
          </div>
        ))}
      </div>
      {/* tablet version */}
      <div className="d-flex w-100 d-xl-none justify-content-between">
        <div style={{ width: `36%` }}>
          <div className="QuickLinks__column" style={{ minHeight: `350px` }}>
            {renderColumn(columns[0], 0)}
          </div>
          <div className="QuickLinks__column">
            {" "}
            {renderColumn(columns[3], 3)}
          </div>
        </div>
        <div className="d-flex" style={{ width: `64%` }}>
          <div className="d-flex flex-column" style={{ width: `55%` }}>
            <div className="QuickLinks__column" style={{ minHeight: `350px` }}>
              {" "}
              {renderColumn(columns[1], 1)}
            </div>
            <div className="QuickLinks__column" style={{ paddingRight: 0 }}>
              {" "}
              {renderColumn(columns[4], 4)}
            </div>
          </div>
          <div className="d-flex flex-column" style={{ width: `45%` }}>
            <div className="QuickLinks__column" style={{ paddingRight: 0 }}>
              {" "}
              {renderColumn(columns[2], 2)}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// QuickLinksLegacy.propTypes = {
//   columns: PropTypes.array.isRequired,
//   hidePayMyBill: PropTypes.bool,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// QuickLinksLegacy.defaultProps = {
//   hidePayMyBill: false,
// }

export default QuickLinks
